module.exports = __webpack_public_path__ + "static/media/10.65752597.png";